<template>
	<div class="search-product">
		<div class="el-search vue-top-padding radius">
			<div class="el-left">
				<el-button
					type="primary"
					size="small"
					v-hasPerm="['upgrade:version:oneclick']"
					icon="el-icon-upload"
					@click="oneUpgrade"
					>{{ $t("common.upgradeBtn") }}</el-button
				>
			</div>
			<div class="el-right">
				<el-form
					ref="upgrademng"
					:model="search"
					:inline="true"
					label-width="10px"
					size="small"
					class="demo-form-inline el-input-height"
				>
					<el-form-item prop="userName">
						<el-input
							v-model="search.userName"
							:placeholder="$t('searchUserMachine.userName')"
							@input="onSubmit"
						></el-input>
					</el-form-item>
					<el-form-item prop="equipmentNo">
						<el-input
							v-model="search.equipmentNo"
							:placeholder="$t('searchUserMachine.equipmentNo')"
							@input="onSubmit"
						></el-input>
					</el-form-item>
					<el-form-item prop="equipmentName">
						<el-input
							v-model="search.equipmentName"
							:placeholder="$t('searchUserMachine.equipmentName')"
							@input="onSubmit"
						></el-input>
					</el-form-item>
					<el-form-item prop="teamId">
						<el-select
							v-model="search.teamId"
							filterable
							:placeholder="$t('upgrade.teamId')"
						>
							<el-option
								v-for="item in machineGroup"
								:no-data-text="$t('common.noData')"
								:no-match-text="$t('common.noData')"
								:key="item.id"
								:label="item.name"
								:value="item.id"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="apkVersion">
						<el-input
							v-model="search.apkVersion"
							:placeholder="$t('upgrade.localAppVersion')"
							@input="onSubmit"
						></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
							$t("common.search")
						}}</el-button>
						<el-button
							@click="resetSearch('upgrademng')"
							icon="el-icon-refresh"
							>{{ $t("common.reset") }}</el-button
						>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SearchProduct",
	props: {
		search: Object,
		selectList: Array,
		machineGroup: Array,
	},
	data() {
		return {
			dateTime: "",
		};
	},
	methods: {
		oneUpgrade() {
			if (this.selectList.length <= 0) {
				this.$message.warning(this.$t("upgrade.check"));
			} else {
				this.$emit("oneUpgrade");
			}
		},
		onSubmit() {
			this.$emit("onSubmit", this.search);
		},
		resetSearch(formName) {
			this.$refs[formName].resetFields();
			this.$toolUtil.clearForm(this.search);
			this.$emit("resetSearch", this.search);
		},
	},
};
</script>

<style lang="sass"></style>
